export default __webpack_public_path__ + "static/media/devices-white.8c1e0837.svg";